(function() {
	var loaderText = document.getElementById("loading-msg");
	var refreshIntervalId = setInterval(function() {
		loaderText.innerHTML = getLoadingText();
	}, 1700);

	function getLoadingText() {
		var strLoadingText;
		var arrLoadingText = ["Loading Dragons 🐉... Just Kidding 😂",
		"Loading Assets",
		"Are you bored?",
		"Hold on",
		"Just a moment",
		"Hacking your device, Nope 😂",
		"Please bear with us",
		"Loading Nuclear bombs 💣",
		"Look! I'm at your back",
		"Patience is a virtue",
		"Why shouldn't you write with a broken pencil? Because it's pointless",
		"What starts with an E, ends with an E and has one letter in it? An Envelope",
		"What has four wheels, and flies? A Garbage truck",
		"What do you call a pig that knows Karate? Pork Chop"
		];
		var rand = Math.floor(Math.random() * arrLoadingText.length);
		return arrLoadingText[rand];
	}
})();
var loader = document.getElementById("preloader");
window.addEventListener("load", function(){
	loader.style.display = "none";
});